import moment from 'moment';

export const formatDateAndTime = (dateString) => {
  const dateFormat = 'MMM DD, YYYY, h:mm';
  return dateString ? moment(dateString).format(dateFormat) : '-';
};
